import 'bootstrap/js/src/modal'
import {
	onSaveAccountForm
} from './applications-functions'
import { loader } from './loader'
import intlTelInput from 'intl-tel-input'
import intlTelInputUtils from 'intl-tel-input/build/js/utils'
import './combodate'

export default function application() {
	(function( $ ) {
		'use strict';

		if (window.std_data.show_info_form) {
			// displayInfoFormModal();
		}
		initFormFields();

		$('.checklist-toggle').click(function (e) {
			e.preventDefault();
			$(this).toggleClass(function () {
				return 'open';
			});
			$(this).closest('.single-result').find('.checklist-wrapper').toggle();
		});

		function displayInfoFormModal (form = 'signin', staticBg = false) {
			$.ajax({
				url: window.glob_obj.ajaxurl,
				method: 'POST',
				dataType: 'json',
				data: {
					action: 'info_form_modal',
					form: form,
					_ajax_nonce: window.std_data.info_form_modal_nonce
				},
				beforeSend: function(){
					loader.show()
				},
				success: function (response) {
					loader.hide()
					$('body').append(response.html);
					let opt = {backdrop: 'static', keyboard: false};
					$('#info-modal').modal(opt).on('hidden.bs.modal', function(e){
						$('#info-modal').remove()
					}).on('shown.bs.modal', function(e){
						initFormFields()
						submitInfoForm()
					});
				},
				error: function(error){
					loader.hide()
					console.log(error);
				}
			});
		}

		function submitInfoForm () {
			$("#info-modal form").submit(function(e){
				e.preventDefault();
				onSaveAccountForm();
				let formData = new FormData($(this)[0]);

				formData.append('action', 'info_form_save');
				formData.append('_ajax_nonce', window.std_data.info_form_save_nonce);
				$.ajax({
					type: "POST",
					url: window.glob_obj.ajaxurl,
					data: formData,
					processData: false,
					contentType: false,
					dataType: "json",
					beforeSend: function(){
						$('#info-modal form .form-error').remove()
						loader.show()
					},
					success: function(data, textStatus, jqXHR) {
						if (data.redirect){
							window.location = data.redirect
						} else {
							loader.hide()
						}

						if (data.errors){
							const errors = data.errors
							const keys = ['marital_status', 'gender', 'birthday'];
							Object.keys(errors).map(function(key, index) {
								if (keys.includes(key)){
									$(`#info-modal form input[name=${key}], #info-modal form select[name=${key}]`).closest('.form-group').append('<span class="form-error">' + errors[key] + '</span>');
								} else {
									$('<span class="form-error">' + errors[key] + '</span>').insertAfter(
										$(`#info-modal form input[name=${key}], #info-modal form select[name=${key}]`)
									);
								}
							});
							if (data.errors.global){
								$('<p class="form-error">' + data.errors.global + '</p>').insertBefore($('#info-modal form > div.row'));
							}
						}
					},
					error: function(data, textStatus, jqXHR) {
						loader.hide()
						console.log(error);
					},
				})
			});
		}
	})( jQuery );
}

function initFormFields () {
	let account_phone = document.querySelector("#phone");
	if (account_phone !== null) {
		let iti = intlTelInput(account_phone, {
			initialCountry: "auto",
			separateDialCode: true,
			hiddenInput: 'phone',
			geoIpLookup: function(callback) {
				$.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
					const countryCode = (resp && resp.country) ? resp.country : "";
					callback(countryCode);
				});
			},
			utilsScript: intlTelInputUtils
		});
		account_phone.addEventListener("countrychange", function() {
			let d = iti.getSelectedCountryData();
			if (d.dialCode !== undefined){
				$('#account_phone').val(`+${d.dialCode}`)
			}
		});
	}

	$('#birthday').combodate({
		firstItem: 'name',
		format: 'yyyy-mm-dd'
	});
}
